'use strict';

var $ = require('jquery');
var MarkerIcon = require('./MarkerIcon.js');

var $mapDiv;
var $addrInfo;
var hasAddress;

function init(mapDiv, addrInfo) {

	$mapDiv = $(mapDiv);

	if ($mapDiv.length === 0) {
		return;
	}

	$addrInfo = $(addrInfo);
	hasAddress = ($addrInfo.attr('data-lat').length > 0) && ($addrInfo.attr('data-lon').length > 0);

	// Set default map center to Minnesota
	var defaultMapCenter = new google.maps.LatLng(45.0114671,-93.4503264);

	// If page has an address element with LatLng attributes, use as map center
	var mapCenter = hasAddress
		? new google.maps.LatLng($addrInfo.attr('data-lat'), $addrInfo.attr('data-lon'))
		: defaultMapCenter;

	var mapOptions = {
		center: mapCenter,
		zoom: 10,
		minZoom: 5,
		maxZoom: 15,
		mapTypeControl: false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		panControl: false,
		scrollwheel: false,
		zoomControl: true,
		streetViewControl: false
	};

	var mapElement = $mapDiv.get(0);
	var map = new google.maps.Map(mapElement, mapOptions);
	var marker = new google.maps.Marker({
		icon: MarkerIcon.icon.default,
		map: map,
		optimized : false,
		position: mapCenter,
		zIndex: 1
	});
}

module.exports = {
	init : init
};
